import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { trackPageViewFromTransition } from 'sh-www/utils/datalayer';

/** @module */
class JoinCompanyRoute extends Route {
  @service auth;
  @service router;
  @service session;
  @service store;

  /** @inheritDoc */
  get queryParams() {
    return {
      id: { refreshModel: true },
    };
  }

  /** @inheritDoc */
  async model({ id: code }) {
    if (!code && !this.session.isAuthenticated) {
      throw new Error('missing invite code');
    }

    if (!this.session.isAuthenticated) {
      try {
        await this.auth.acceptInvite(code);
      } catch (e) {
        return {
          errors: e.errors,
        };
      }
    }

    return this.session.currentUser;
  }

  /** @inheritDoc */
  setupController(controller) {
    super.setupController(...arguments);

    // remove code from url
    window.history.replaceState(null, null, window.location.pathname);

    // Show logout button if user is signed in
    if (this.session.isAuthenticated) {
      this.controllerFor('application').setProperties({
        simpleHeaderRightText: 'Logout',

        simpleHeaderRightAction: () => {
          this.session.invalidate();
        },
      });
    }
  }

  /** @inheritDoc */
  resetController(controller, isExiting) {
    super.resetController(...arguments);

    if (isExiting) {
      controller.set('id', null);
      controller.completeSignup.cancelAll({ resetState: true });
      controller.onGoogleSSO.cancelAll({ resetState: true });
    }
  }

  /** @inheritDoc */
  activate(transition) {
    super.activate(...arguments);
    trackPageViewFromTransition(this, transition, '/joincompany/');
  }

  /** @inheritDoc */
  deactivate() {
    super.deactivate(...arguments);

    this.controllerFor('application').setProperties({
      simpleHeaderRightText: '',
      simpleHeaderRightAction: null,
    });
  }
}

export default JoinCompanyRoute;
